<template>
	<div class="index">
		<banner />
		<div class="products">
			<div class="main-title">Products</div>
            <div class="image-wrap">
                <div class="btn-wrap" data-knowbox-track="gw006" data-knowbox-attrs="tohref:false;when:exposure">
                    <div class="upload-app"></div>
                    <div class="upload-win7-lower" @click="handleAction('win7Lower')"></div>
                    <!-- <div class="upload-win7-upper" @click="handleAction('win7Upper')"></div>
                    <div class="upload-mac" @click="handleAction('mac')"></div> -->
                </div>
            </div>
			<!-- <div class="school-assist">
				<div class="title">校园智能教学工具</div>
				<div class="list">
					<div 
                        class="item" 
                        v-for="(item, index) in schoolAssistList" 
                        :key="index"
                        @click="() => { handleClick(item) }"
                    >
						<img :src="item.icon" class="icon" />
						<div class="name">{{item.name}}</div>
					</div>
				</div>
			</div> -->
			<!-- <div class="family-assist">
				<div class="title">家庭辅导</div>
				<div class="list"> -->
					<!-- <div
						class="item"
						v-for="(item, index) in familyAssistList"
						:key="index"
						:class="{'more': index === familyAssistList.length - 1}"
                        @click="() => { handleClick(item) }"
					> -->
          <!-- <div
						class="item"
						v-for="(item, index) in familyAssistList"
						:key="index"
            @click="() => { handleClick(item) }"
					>
						<img :src="item.icon" class="icon" />
						<div class="name" v-if="item.name">{{item.name}}</div>
					</div>
				</div>
			</div> -->

      <!-- <div class="family-assist">
        <div class="title">学科培训</div>
        <div class="list"> -->
          <!-- <div
            class="item"
            v-for="(item, index) in familyAssistList"
            :key="index"
            :class="{'more': index === familyAssistList.length - 1}"
                        @click="() => { handleClick(item) }"
          > -->
          <!-- <div
              class="item"
              v-for="(item, index) in traingAssistList"
              :key="index"
              @click="() => { handleClick(item) }"
          >
            <img :src="item.icon" class="icon" />
            <div class="name" v-if="item.name">{{item.name}}</div>
          </div>
        </div>
      </div> -->

		</div>
		<div class="charity">
			<div class="title">Knowbox Charity 盒公益</div>
            <swiper :options="swiperOption" ref="swiper" class="swiper" v-if="newsInfo.length > 1">
                <swiper-slide v-for="(item, index) in newsInfo" :key="index">
                    <div class="gallery" @click="() => { jump(item) }">
                        <div class="focus">
                            <img :src="item.image_p_home" class="pic"/>
                        </div>
                        <div class="next" @mouseenter="mouseenter" @mouseleave="mouseleave"></div>
                    </div>
                    <div class="text" @click="() => { jump(item) }">{{newsInfo.title}}</div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
            <div v-else>
                <div class="gallery" @click="() => { jump(newsInfo[0]) }">
                    <div class="focus">
                        <img :src="newsInfo[0].image_p_home" class="pic"/>
                    </div>
                    <div class="next" @mouseenter="mouseenter" @mouseleave="mouseleave"></div>
                </div>
                <div class="text" @click="() => { jump(newsInfo[0]) }">{{newsInfo[0].title}}</div>
            </div>
            <div class="cube"></div>
		</div>
	</div>
</template>
<script>
	import { Component, Vue } from 'vue-property-decorator';
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import Banner from '@/components/banner/index.vue';
    import { EventBus } from '@/utils/eventBus.js';
    
	//
	const YOUPAI = 'https://appd.knowbox.cn/ss/activity/knowbox-web/img/';
    const YOUPAINEW = 'https://appd.knowbox.cn/ss/app-icon/';

	@Component({
		components: {
            swiper,
            swiperSlide, 
			Banner
		}
	})
	export default class Index extends Vue {
		swiperOption = {
            loop: true,
            // autoplay: {
            //     delay: 2500,
            //     disableOnInteraction: false
            // },
			pagination: {
                el: '.swiper-pagination',
                clickable: true
			}
		};

		get swiper() {
			return this.$refs.swiper.swiper;
        }

		schoolAssistList = [
			{
                id: 'teacher',
				icon: `${YOUPAINEW}xhls/120_120.png`,
                name: '小盒老师',
                query: 'block=teacher'
			},
			{
                id: 'student',
				icon: `${YOUPAINEW}xhxs/120_120.png`,
                name: '小盒学生',
                query: 'block=student'
			},
			// {
            //     id: 'family-school',
			// 	icon: `${YOUPAI}family-school-app.png`,
			// 	name: '家校盒子'
			// },
			// {
            //     id: 'xiaoxiangshuju',
			// 	icon: `${YOUPAI}xiaoxiangshuju-web.png`,
			// 	name: '小盒数据'
			// }
		];
		familyAssistList = [
			{
                id: 'parent',
				icon: `${YOUPAINEW}xhxx/512_512.png`,
                name: '小盒学习',
                query: 'block=parent'
			},
			// {
            //     id: 'aiclass',
			// 	icon: `${YOUPAI}aiclass-app.png`,
			// 	name: '小盒课堂',
            //     url: 'https://xiaoheketang.knowbox.cn'
			// },
			// {
            //     id: 'program',
			// 	icon: `${YOUPAI}program-app.png`,
			// 	name: '小象编程',
            //     url: 'https://code.knowbox.cn'
			// },
			// {
            //     id: 'english',
			// 	icon: `${YOUPAI}english-app.png`,
			// 	name: '小象英语',
            //     query: 'block=english'
			// },
			// {
            //     id: 'science',
			// 	icon: `${YOUPAI}science-app.png`,
			// 	name: '小象科学',
            //     query: 'block=science'
			// },
			// {
            //     id: 'ocr',
			// 	icon: `${YOUPAI}ocr-app.png`,
			// 	name: '拍作业',
            //     query: 'block=ocr'
			// },
			// {
      //           id: 'plus',
			// 	icon: `${YOUPAI}plus.png`,
			// 	name: ''
			// }
        ];

    traingAssistList = [
      {
        id: 'parentnew',
        icon: `https://susuanqiniu.knowbox.cn/xiaoheguanwang0220220207.png`,
        name: '小盒课堂',
        query: 'block=parentnew'
      },
    ]

        mouseenter(e) {}

        mouseleave(e) {}

        handleClick(item) {
            if (item.id !== 'aiclass' && item.id !== 'program') {
                this.$router.push({
                    path: `/product${item.query ? '?' + item.query : ''}`
                });

                EventBus.$emit('router.change', '/product');
            } else {
                window.open(item.url);
            }
        }

        jump(news) {
            this.$router.push({
                path: `/news/${news.news_id}`
            });
        }

        get newsInfo() {
            return this.$store.state.common.newsHome;
        }

        // 小盒课堂PC端下载
        handleAction(action) {
            switch (action) {
                case 'win7Lower': {
                    window.websdk.log("gw007", false, {});
                    window.location.href = "https://aiclasspc.knowbox.cn/";
                    break;
                }
                case 'win7Upper': {
                    window.websdk.log("gw008", false, {});
                    window.location.href = "https://apps.knowbox.cn/xhkt/pc/%E5%B0%8F%E7%9B%92%E8%AF%BE%E5%A0%82setup.exe";
                    break;
                }
                case 'mac': {
                    window.websdk.log("gw009", false, {});
                    window.location.href = "https://apps.knowbox.cn/xhkt/pc/%E5%B0%8F%E7%9B%92%E8%AF%BE%E5%A0%82mac.dmg";
                    break;    
                }
            }
        }
	}
</script>
<style lang="scss">
	.index {
        padding-top: 100px;
        box-sizing: border-box;
		.products {
			padding-top: 182px;
			box-sizing: border-box;
			width: 1200px;
			margin: 0 auto;
			.main-title {
                text-indent: -99999px;
                width: 267px;
                height: 89px;
                background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/Productsx2.png) no-repeat;
                background-size: 100% 100%;
			}
            .image-wrap {
                position: relative;
                height: 823px;
                // background: url(https://susuanqiniu.knowbox.cn/20220214-knowbox.cn.jpg) center/cover no-repeat;
                background: url('https://susuanqiniu.knowbox.cn/fe/www-m/product_xhkt.jpg') center/cover no-repeat;
                .btn-wrap {
                    position: absolute;
                    left: 70px;
                    bottom: 110px;
                    display: flex;
                    & > div {
                        width: 140px;
                        height: 140px;
                        margin-right: 20px;
                        cursor: pointer;
                    }
                    .upload-app {
                        cursor: initial;
                        background: url('https://susuanqiniu.knowbox.cn/fe/www-m/upload_app.png?v=1') center/cover no-repeat;
                    }
                    .upload-win7-lower {
                        background: url('https://susuanqiniu.knowbox.cn/fe/www-m/upload_pc_icon.png?v=1') center/cover no-repeat;
                        &:hover {
                            background: url('https://susuanqiniu.knowbox.cn/fe/www-m/upload_pc_icon_hover.png?v=1') center/cover no-repeat;
                        }
                    }
                    .upload-win7-upper {
                        background: url('https://susuanqiniu.knowbox.cn/fe/www-m/upload_win7_upper.png?v=1') center/cover no-repeat;
                        &:hover {
                            background: url('https://susuanqiniu.knowbox.cn/fe/www-m/upload_win7_upper_hover.png?v=1') center/cover no-repeat;
                        }
                    }
                    .upload-mac {
                        background: url('https://susuanqiniu.knowbox.cn/fe/www-m/upload_mac.png?v=1') center/cover no-repeat;
                        &:hover {
                            background: url('https://susuanqiniu.knowbox.cn/fe/www-m/upload_mac_hover.png?v=1') center/cover no-repeat;
                        }
                    }
                }
            }
			// .school-assist,
			// .family-assist {
			// 	.title {
			// 		padding: 91px 0 19px;
			// 		font-size: 24px;
			// 		color: #39393d;
			// 		border-bottom: 1px solid #39393d;
            //         font-family: PingFangSC-light;
			// 	}
			// 	.list {
			// 		width: 1200px;
			// 		display: flex;
			// 		flex-flow: row wrap;
			// 		padding-top: 33px;
			// 		box-sizing: border-box;
			// 		.item {
			// 			text-align: center;
			// 			width: 25%;
			// 			margin-bottom: 102px;
            //             cursor: pointer;
            //             .icon {
            //                 position: relative;
            //                 transition: top 0.1s ease-in-out;
            //                 top: 0;
            //                 width: 128px;
            //                 height: 128px;
            //             }
			// 			.name {
			// 				width: 100px;
			// 				height: 30px;
			// 				line-height: 30px;
			// 				text-align: center;
			// 				background: #fb5000;
			// 				box-shadow: 0 11px 21px 0 rgba(62, 66, 186, .25);
			// 				border-radius: 20px;
			// 				color: #fff;
			// 				margin: 20px auto 0;
            //                 font-size: 16px;
            //                 font-family: PingFangSC-light;
			// 			}
            //             &:hover {
            //                 .icon {
            //                     top: -8px;
            //                 }
            //             }
			// 		}
			// 		.more {
			// 			margin-top: 49px;
            //             .icon {
            //                 position: static;
            //                 width: 81px;
            //                 height: 81px;
            //             }
            //             > img {
            //                 cursor: pointer;
            //             }
			// 		}
			// 	}
			// }
			// .family-assist {
            //     .title {
            //         padding-top: 28px;
            //     }
			// 	.list {
			// 		.item {
			// 			.name {
			// 				background: #3e42ba;
			// 			}
			// 		}
			// 	}
			// }
		}
		.charity {
			width: 1040px;
			margin: 0 auto;
            padding: 83px 0 170px;
            position: relative;
			.title {
                text-indent: -99999px;
                width: 427px;
                height: 100px;
                background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/Charity@2x-new-1.png) no-repeat;
                background-size: 100% 100%;
			}
			.gallery {
				position: relative;
                z-index: 10;
				.focus {
					margin: 10px 0 20px;
                    .pic {
                        width: 1040px;
                        display: block;
                        cursor: pointer;
                    }
				}
				.next {
					width: 118px;
					height: 118px;
					background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/nextx2.png) no-repeat;
                    background-size: 100% 100%;
					position: absolute;
					right: 50px;
					bottom: -65px;
                    cursor: pointer;
                    transition: right .1s ease;
                    z-index: 100;
                    &:hover {
                        right: 40px;
                    }
				}
			}
            .text {
                font-size: 24px;
                font-family: PingFangSC-light;
                cursor: pointer;
            }
            .cube {
                width: 643px;
                height: 643px;
                position: absolute;
                background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/cubex2.png) no-repeat;
                background-size: 100% 100%;
                right: -205px;
                top: 5px;
                transform: rotate(0deg);
            }
            .swiper {
                .swiper-slide {
                    padding-bottom: 35px;
                }
            }
            .swiper-pagination {
                bottom: 60px;
                left: 50%;
                width: 30%;
                transform: translate(-50%);
                .swiper-pagination-bullet {
                    width: 8px;
                    height: 8px;
                    background: #000;
                    border-radius: 0;
                    &.swiper-pagination-bullet-active {
                        width: 90px;
                        background: #FB5000;
                    }
                }
            }
		}
	}
</style>